import { styled } from '@mui/material/styles';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

export type ButtonsSettings = {
  confirmText?: string;
  confirmColor?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  cancelText?: string;
  cancelColor?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
};
export const StyledDialog = styled(Dialog)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  '& .MuiDialog-paper': {
    backgroundColor: theme.palette.background.paper,
    backgroundImage: 'none',
    padding: theme.spacing(3),
  },
}));
export const StyledInformationDialog = styled(Dialog)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  '& .MuiDialog-paper': {
    width: 343,
    zIndex: 2000,
    padding: theme.spacing(2),
  },
}));

export const StyledInformationDialogTitle = styled(DialogTitle)(({ theme }) => ({
  justifyContent: 'left',
  display: 'flex',
  fontSize: theme.spacing(2),
  lineHeight: theme.spacing(3),
  fontWeight: 'bold',
  textAlign: 'left',
  padding: 0,
}));

export const StyledInformationDialogContent = styled(DialogContent)(({ theme }) => ({
  margin: theme.spacing(2, 2, 2),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));
